module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iMTEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUuNSAxMWE1LjUgNS41IDAgMSAxIDAtMTEgNS41IDUuNSAwIDAgMSAwIDExem0tLjg1NS0xLjk2NWwuOTUxLjAwNiAxLjc4Mi0yLjkwNiAxLjQ2My0uMDEzYy4yOTcgMCAuNTQyLS4yNjUuNTQyLS41ODcgMC0uMzIyLS4yMzQtLjU4Ny0uNTQyLS41ODdINy4zNjdMNS41OTcgMi4wNEg0LjY0bC44OTYgMi45MTNINC4wNDhsLS42NzQtMS4wNGgtLjk5bC41NDIgMS42MjctLjUwOCAxLjYyNmguOTU2bC42NzQtMS4wMzhoMS40NzdsLS44OCAyLjkwNnoiIGZpbGw9IiM1QUZGQUMiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/flightdetail-icon.svg
// module id = 736
// module chunks = 0